import { PropsWithChildren, useEffect, useMemo } from 'react'
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom'
import { ROUTES } from '../constants'
import { selectAuthorized } from 'lib/helpers/selectors'
import usePathListener from 'hooks/usePathListener'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setExternalLinkURL } from 'store/SharedData/sharedData.reducer'
import { selectExternalLinkURL } from 'store/SharedData/sharedData.selectors'
import { getUpdatedURL } from 'lib/helpers/shared.helpers'

interface IPrivateHubsProps {
  inverse?: boolean
}

export const PrivateHub = ({
  inverse = false,
  children,
}: PropsWithChildren<IPrivateHubsProps>) => {
  const dispatch = useAppDispatch()

  const { pathname } = useLocation()
  const [params] = useSearchParams()

  const navigate = useNavigate()

  const authorized = useAppSelector(selectAuthorized)
  const externalLinkURL = useAppSelector(selectExternalLinkURL)

  usePathListener(pathname, !authorized)

  const showComponent = (authorized && !inverse) || (!authorized && inverse)

  const defaultPath = useMemo(
    () =>
      externalLinkURL ? externalLinkURL : inverse ? ROUTES.HOME : ROUTES.LOGIN,
    [externalLinkURL, inverse]
  )

  useEffect(() => {
    const cleanUrl = getUpdatedURL(params, 'redirect', pathname)

    if (!showComponent) {
      if (params.get('redirect')) {
        dispatch(setExternalLinkURL(cleanUrl))
      }
      navigate(defaultPath, { replace: true })
    } else {
      if (params.get('redirect')) {
        window.history.replaceState(null, '', cleanUrl)
      }
    }
  }, [
    defaultPath,
    externalLinkURL,
    params,
    pathname,
    showComponent,
    dispatch,
    navigate,
  ])

  return <>{showComponent ? children : null}</>
}

export default PrivateHub
